//
import React, { Component } from "react"
import { createOrderByFilterGroup, genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
} from "shared/search/containers/Filter/Filters"

import { FileProjectFilter } from "shared/search/containers/Filter/FileFilters"

export class FileListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.attachment.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.attachment.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "FileListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter files by your lists.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class FileProjectFilterGroup extends Component {
    static defaultProps = {
        filters: [FileProjectFilter],
        uniqueFilterGroupId: "FileProjectFilterGroup",
        displayLabel: "Issues",
        helpText: "Filter results by the issue they are tagged to.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const FileOrderByFilterGroup = createOrderByFilterGroup({
    // uniqueFilterId = "attachmentOrderBy"
    quorumDataType: DjangIO.app.models.QuorumDataType.attachment.value,
})
